import DOMPurify from "dompurify";

export function useSanitize() {
  function sanitizeUrl(url: string | null | undefined): string {
    if (!url) return "";
    const clean = DOMPurify.sanitize(url.trim(), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });

    try {
      const parsed = new URL(clean, window.location.origin);
      const safeProtocols = ["http:", "https:", "mailto:", "tel:", "ftp:"];
      return safeProtocols.includes(parsed.protocol) ? parsed.href : "";
    } catch {
      return /^(?!\s*(javascript:|data:|vbscript:))/i.test(clean) ? clean : "";
    }
  }

  function sanitizeStyle(style: any): any {
    if (!style) return "";
    if (typeof style === "object") {
      const safe: Record<string, string> = {};
      for (const key in style) {
        const val = style[key];
        if (!/url\s*\(\s*['"]?\s*javascript:/i.test(val)) {
          safe[key] = DOMPurify.sanitize(val, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
        }
      }
      return safe;
    }
    return /url\s*\(\s*['"]?\s*javascript:/i.test(style) ? "" : DOMPurify.sanitize(style, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  }

  function sanitizeClass(value: any): any {
    if (!value) return "";
    if (typeof value === "string") {
      return DOMPurify.sanitize(value.replace(/[^\w\-_\s]/g, ""), {
        ALLOWED_TAGS: [],
        ALLOWED_ATTR: []
      });
    }

    if (Array.isArray(value)) return value.map((v) => sanitizeClass(v));

    if (typeof value === "object") {
      const clean: Record<string, boolean> = {};
      for (const key in value) {
        const safeKey = sanitizeClass(key);
        clean[safeKey] = !!value[key];
      }
      return clean;
    }

    return "";
  }

  function sanitizeFilename(name: string, maxLen = 200) {
    if (!name) return "";
    name = name.normalize("NFC");
    name = name.replace(/.*[\\/]/, "");
    // eslint-disable-next-line no-control-regex
    name = name.replace(/[\u0000-\u001F\u007F]/g, "");
    name = name.replace(/[\u202A-\u202E\u2066-\u2069]/g, "");
    // eslint-disable-next-line no-control-regex, no-useless-escape
    name = name.replace(/[\"'<>:;|?*\x00\/\\]/g, "_");
    name = name.replace(/\s+/g, " ").trim();
    if (name.length > maxLen) name = name.slice(0, maxLen);
    return name || "file";
  }

  return {
    sanitizeUrl,
    sanitizeStyle,
    sanitizeClass,
    sanitizeFilename
  };
}
